import { TextToSpeechWeb } from "./TextToSpeechWeb";

export class TextToSpeechService {
  constructor(setCurrentWordIndex) {
    this.ttsInstance = new TextToSpeechWeb();
    this.setCurrentWordIndex = setCurrentWordIndex;
    this.isMounted = true;
    this.interval = null;
  }

  isSupported() {
    return !!this.ttsInstance.synth;
  }

  startTTS(text, wordsLength) {
    const isMobile = /Mobi|Android/i.test(navigator.userAgent) || navigator.maxTouchPoints > 0;
    this.isMounted = true;
    if (isMobile) {
      this.mobileTTSHandler(text, wordsLength);
    } else {
      this.desktopTTSHandler(text, wordsLength);
    }
  }

  mobileTTSHandler(text, wordsLength) {
    let boundaryFired = false;

    const handleBoundary = (event) => {
      boundaryFired = true;
      if (this.isMounted && event.name === "word") {
        this.setCurrentWordIndex((prev) => Math.min(prev + 1, wordsLength));
      }
    };

    const handleEnd = () => {
      if (this.isMounted) {
        this.setCurrentWordIndex(wordsLength);
      }
    };

    setTimeout(() => {
      if (this.isMounted) {
        this.ttsInstance.speak(text, handleEnd, handleBoundary);

        // Fallback timer if `onboundary` doesn't trigger
        setTimeout(() => {
          if (!boundaryFired) {
            console.warn("onboundary not firing, using fallback timer.");
            this.interval = setInterval(() => {
              this.setCurrentWordIndex((prev) => {
                if (prev < wordsLength) {
                  return prev + 1;
                } else {
                  clearInterval(this.interval);
                  return prev;
                }
              });
            }, 150);
          }
        }, 500);
      }
    }, 50);
  }

  desktopTTSHandler(text, wordsLength) {
    const handleBoundary = (event) => {
      if (this.isMounted && event.name === "word") {
        this.setCurrentWordIndex((prev) => Math.min(prev + 1, wordsLength));
      }
    };

    const handleEnd = () => {
      if (this.isMounted) {
        this.setCurrentWordIndex(wordsLength);
      }
    };

    setTimeout(() => {
      if (this.isMounted) {
        this.ttsInstance.speak(text, handleEnd, handleBoundary);
      }
    }, 50);
  }

  stop() {
    this.isMounted = false;
    clearInterval(this.interval);
    this.ttsInstance.stop();
  }
}
